import { render, staticRenderFns } from "./CurrentSituationStationCards.vue?vue&type=template&id=c84d064c&scoped=true"
import script from "./CurrentSituationStationCards.vue?vue&type=script&lang=js"
export * from "./CurrentSituationStationCards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c84d064c",
  null
  
)

export default component.exports